<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const props = defineProps<{
  disableReason?: string
}>()
const emit = defineEmits<{
  click: []
}>()

const { t } = useI18n()

const disabled = computed(() => !!props.disableReason)
const onClick = () => {
  if (disabled.value) {
    return
  }

  emit('click')
}
</script>

<template>
  <v-btn
    density="compact"
    variant="text"
    icon="edit"
    :color="disabled ? `grey` : undefined"
    :title="disabled ? props.disableReason : t('button.edit')"
    :style="disabled ? 'cursor: not-allowed' : undefined"
    @click.stop="onClick"
  />
</template>

<style scoped lang="scss"></style>
